import { render, staticRenderFns } from "./ProductTypeGroupedProduct.vue?vue&type=template&id=f668ab3e"
import script from "./ProductTypeGroupedProduct.vue?vue&type=script&lang=ts"
export * from "./ProductTypeGroupedProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports